module.exports = __webpack_public_path__ + "static/media/logo.314b8040.png";